/** @typedef {import('headlight-configurable-application').Pict} Pict */
const PictProvider = require('pict-provider');
const libScanGeolocation = require('headlight-qrcode-web/source/scanning/Scan-Geolocation.js');

class GeoProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/**
	 * Function to get user's geocoordinates from the browser. Returns null if it cannot get them.
	 * @param {Object} [pOptions]
	 * @param {boolean} [pOptions.NoPrompt] - Read the browser position only when permission is already granted; never ask.
	 * @return {Promise<Object|null>}
	 */
	async getGeoCoords(pOptions)
	{
		// Attempt to fetch a location from the native app.
		try
		{
			const coords = await this.fable.NativeBridge.getLocation();
			return {
				CaptureLatitude: coords.Latitude,
				CaptureLongitude: coords.Longitude,
				Latitude: coords.Latitude,
				Longitude: coords.Longitude,
			};
		}
		catch (error)
		{
			console.log('No native location method available: ', error);
		}

		// Check for a passed location from the native app if available.
		if (typeof window.Mixins?.deviceGeolocation === 'object')
		{
			return {
				CaptureLatitude: window.Mixins.deviceGeolocation.Latitude || window.Mixins.deviceGeolocation.latitude,
				CaptureLongitude: window.Mixins.deviceGeolocation.Longitude || window.Mixins.deviceGeolocation.longitude,
				Latitude: window.Mixins.deviceGeolocation.Latitude || window.Mixins.deviceGeolocation.latitude,
				Longitude: window.Mixins.deviceGeolocation.Longitude || window.Mixins.deviceGeolocation.longitude,
			};
		}

		if (pOptions?.NoPrompt)
		{
			const tmpPosition = await libScanGeolocation.getPositionIfPermitted();
			return tmpPosition ? { CaptureLatitude: tmpPosition.Latitude, CaptureLongitude: tmpPosition.Longitude, Latitude: tmpPosition.Latitude, Longitude: tmpPosition.Longitude } : null;
		}

		return await new Promise((resolve, reject) =>
		{
			window.navigator.geolocation.getCurrentPosition(
				(position) =>
				{
					resolve({
						CaptureLatitude: position.coords.latitude,
						CaptureLongitude: position.coords.longitude,
						Latitude: position.coords.latitude,
						Longitude: position.coords.longitude,
					});
				},
				() =>
				{
					this.pict.log.info('Couldn\'t get geolocation, returning null...');
					resolve(null);
				},
				{
					maximumAge: 12*60*60*1000,
				},
			);
		});
	}
}

module.exports = GeoProvider;
module.exports.default_configuration = {};
